import {inject, injectable} from 'inversify';

import type {BaseDomainFactory} from '../../../core/domain/Base/BaseDomain.factory';

import {ModelsRegistry} from '../../system/modelsRegistry/ModelsRegistry';
import {PaymentModel} from './Payment.model';

@injectable()
export class PaymentFactory
  implements BaseDomainFactory<PaymentModel, PaymentModel.Props>
{
  constructor(
    @inject(ModelsRegistry)
    private readonly modelsRegistry: ModelsRegistry,
  ) {}

  create(props: PaymentModel.Props): PaymentModel {
    return this.modelsRegistry.put(new PaymentModel(props));
  }
}
